import "./contactForm.css";
import tech from "./tech.png";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { AlertContext } from "../context/alertContext";

export const ContactForm = () => {
 const {successShow} = React.useContext(AlertContext);

  const form = useRef();
  const userName = useRef();
  const userEmail = useRef();
  const userText = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_t6ppv5g",
        "template_phlyb2a",
        form.current,
        "user_0VPpQwsZp1Tn5RJ9Pd35v"
      )
      .then(
        (result) => {
          userName.current.value = "";
          userEmail.current.value = "";
          userText.current.value = "";
          successShow();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="contactForm">
      <div>Contact</div>
      <div>
        <div className="formDiv">
          <div>
            <form ref={form} onSubmit={sendEmail}>
              <input
              ref={userName}
                type="text"
                required
                placeholder="Please Enter your Name"
                name="user_name"
              />
              <input
              ref={userEmail}
                type="email"
                required
                name="user_email"
                placeholder="Please Enter your email"
              />

              <textarea
              ref={userText}
                name="message"
                cols="30"
                rows="10"
                placeholder="Description"
              ></textarea>

              <div className="formBtn">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
        <div className="techPic">
          <img src={tech} alt="" />
        </div>
      </div>
    </div>
  );
};